// import logo from './logo.svg';
import "./App.css";
import React, { useState, useEffect } from "react";
import Urls from "./Urls";
import { connect } from "react-redux";
import * as actions from "./store/authActions";
import axios from "axios";
import { ThemeProvider } from "@mui/material/styles";
import { SDETheme } from "./Theme";

import { RecoilRoot } from "recoil";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export default function App(props) {
  // const [level, setLevel] = useState('es');
  const [map, setMap] = useState();
  // const [plan, setPlan] = useState(() => {
  //   const savedPlan = localStorage.getItem('plan')
  //   const initialVal = JSON.parse(savedPlan)
  //   return initialVal || ''
  // })
  const [suggestedSwaps, setSuggestedSwaps] = useState();

  const userSettings = {
    //   level: level,
    map: map,
    //   plan: plan,
    //   suggestedSwaps: suggestedSwaps,
    //   setLevel,
    setMap,
    //   setPlan,
    setSuggestedSwaps,
  };

  return (
    <div className="App">
      <RecoilRoot>
        <ThemeProvider theme={SDETheme}>
          <Urls mySettings={userSettings} {...props} />
        </ThemeProvider>
      </RecoilRoot>
    </div>
  );
}
